import {create} from "zustand";

export interface VanityDomainState {
    isSessionAvailableOnVanity: boolean;
    setIsSessionAvailableOnVanity: (isSessionAvailableOnVanity:boolean) => void;
  }
  
export const useVanityDomainStatusStore = create<VanityDomainState>((set) => ({
    isSessionAvailableOnVanity: false,
    setIsSessionAvailableOnVanity: (isSessionAvailableOnVanity) => set(() => ({ isSessionAvailableOnVanity }))
 }));
